<div class="body-container">
  <ng-template authorizeShow authorizeFeatureFlag="UseEnvironmentIndicator">
    <div
      id="env-indicator"
      class="text-light text-center text-uppercase bold small"
      [class.bg-success]="environmentName === 'Local'"
      [class.bg-danger]="environmentName === 'Prod'"
      [class.bg-warning]="
        environmentName !== 'Prod' && environmentName !== 'Local'
      "
    >
      {{ environmentName }}
    </div>
  </ng-template>
  <app-navigation-v2></app-navigation-v2>
  <app-header-bar
    [title]="activeComponentService.title$ | async"
  ></app-header-bar>
  <main
    cdkVirtualScrollingElement
    [observe]="['clientWidth', 'offsetWidth']"
    (observeResize)="onMainResize($event)"
    [style.--scrollbar-width.px]="scrollbarWidth"
  >
    <div class="body-panels">
      <app-alert-banner></app-alert-banner>
      <app-payment-required></app-payment-required>
      <app-outage></app-outage>
      @if (isDemo$ | async) {
        <app-start-banner></app-start-banner>
      }
      <app-guide-banner></app-guide-banner>
    </div>

    <div class="outlet d-flex flex-column" [class.demo]="isDemo$ | async">
      @if (isDemo$ | async) {
        <div class="demo-label">
          <h4 class="ms-3 mt-2">This is your demo register</h4>
        </div>
      }

      <app-demo-banner></app-demo-banner>

      <app-sub-navigation></app-sub-navigation>

      <router-outlet
        (activate)="activeComponentService.onActivate($event)"
        (deactivate)="activeComponentService.onDeactivate()"
      ></router-outlet>
    </div>
  </main>
</div>
